import React, { Suspense } from "react";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { Redirect, Route, Switch } from "react-router-dom";
import { InvestigationsPage } from "./investigations/InvestigationsPage";
import { InvestigationCreateModal } from "./investigations/investigation-create-modal/InvestigationCreateModal";
import { InvestigationSingle } from "./investigations/investigation-single/InvestigationSingle";
import { InvestigationEdit } from "./investigations/investigation-edit/InvestigationEdit";

export default function QCPage() {
  return (
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          {<Redirect to={"/QC/Investigations"} from={"/QC"} exact={true} />}
          <Route path={"/qc/investigations/new"}>
            {({ history, match }) => (
                <InvestigationCreateModal
                    show={match != null}
                    onHide={() => {
                      history.push("/qc/investigations");
                    }}
                />
            )}
          </Route>

          <ContentRoute
              path={"/qc/investigations/:id/edit"}
              component={InvestigationEdit}
          />

          <ContentRoute
              path={"/qc/investigations/:id/view"}
              component={InvestigationSingle}
          />

          <ContentRoute
              path={"/qc/investigations"}
              component={InvestigationsPage}
          />
        </Switch>
      </Suspense>
  );
}
